import { Component } from "react"
import PropTypes from "prop-types"
import { Button, DialogActions, DialogContent } from "@mui/material"
import "./style.scss"

class UpdateDialog extends Component {
  static propTypes = {
    close: PropTypes.func,
    update: PropTypes.func.isRequired,
  }

  constructor(props, ...args) {
    super(props, ...args)
    this.state = { updateDisabled: false }
  }

  update = () => {
    const { update } = this.props
    const newState = { ...this.state, updateDisabled: true }
    this.setState(newState)
    update()
  }

  render() {
    const { close } = this.props
    const { updateDisabled } = this.state

    return <>
      <DialogContent className="update-experiment-dialog">
        Updating the experiment will replace all existing dates and positions. Are you sure you want to overwrite the experiment?
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" onClick={this.update} disabled={updateDisabled}>Update</Button>
      </DialogActions>
    </>
  }
}

export default UpdateDialog
